import React from 'react';
import PropTypes from 'prop-types';

function XButton({ active, activeColor, color }) {
  return (
    <>
      <path
        d="M626.339 263.501C626.339 274.776 617.2 283.916 605.924 283.916C594.648 283.916 585.509 274.776 585.509 263.501C585.509 252.226 594.648 243.086 605.924 243.086C617.2 243.086 626.339 252.226 626.339 263.501Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M617.988 253.117L616.369 251.498L606.113 261.755L595.857 251.498L594.238 253.117L604.498 263.373L594.238 273.63L595.857 275.248L606.113 264.992L616.369 275.248L617.988 273.63L607.732 263.373L617.988 253.117Z"
        fill="#1A89D3"
      />
    </>
  );
}

XButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

XButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#464A56',
};

export default XButton;
